export default __webpack_public_path__ + "123e24b3536e641e6402e277b77706a6.svg";